export default {
  methods: {
    displayDocumentIDGTypeA(tag, num) {
      let idg = num.toString();
      idg = idg.slice(-6);
      idg = tag + idg;
      return idg;
    },
    displayDocumentID(id) {
      let idg = id.toString();
      let str1 = idg.slice(idg.length - 9, idg.length - 6);
      let str2 = idg.slice(idg.length - 6, idg.length - 3);
      let str3 = idg.slice(idg.length - 3, idg.length);
      idg = str1 + " " + str2 + " " + str3;
      return idg;
    },
    displayMobilePhoneNumber9Digits(phone) {
      let mob = phone;
      let str1 = mob.slice(mob.length - 9, mob.length - 6);
      let str2 = mob.slice(mob.length - 6, mob.length - 3);
      let str3 = mob.slice(mob.length - 3, mob.length);
      mob = "0" + str1 + " " + str2 + " " + str3;
      return mob;
    }
  }
};
